import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const Experience = ({ time, title, company, location, description, responsibilities, results }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="mb-6">
      <div 
        className="bg-zinc-800/50 backdrop-blur-sm rounded-xl p-6 border border-zinc-700/50 hover:border-zinc-600 transition-all duration-300 hover:shadow-xl hover:shadow-green-500/10 cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex justify-between items-start mb-3">
          <div className="flex-1">
            <h3 className="text-xl font-bold text-white mb-1">{title}</h3>
            <h4 className="text-base text-zinc-400 mb-2">{company}</h4>
            <div className="flex flex-wrap gap-2 text-sm text-zinc-500">
              <span className="text-green-400 font-medium">{time}</span>
              {location && <span>• {location}</span>}
            </div>
          </div>
          <button className="text-zinc-400 hover:text-white transition-colors">
            {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
          </button>
        </div>

        {isExpanded && (
          <div className="mt-4 space-y-4">
            {description && (
              <p className="text-zinc-300 text-sm leading-relaxed">{description}</p>
            )}
            
            {responsibilities && responsibilities.length > 0 && (
              <div>
                <h5 className="text-green-400 font-semibold text-sm mb-2">Responsabilidades:</h5>
                <ul className="space-y-1">
                  {responsibilities.map((resp, index) => (
                    <li key={index} className="text-zinc-300 text-sm flex items-start">
                      <span className="text-green-400 mr-2">•</span>
                      <span>{resp}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {results && results.length > 0 && (
              <div>
                <h5 className="text-green-400 font-semibold text-sm mb-2">Resultados:</h5>
                <ul className="space-y-1">
                  {results.map((result, index) => (
                    <li key={index} className="text-zinc-300 text-sm flex items-start">
                      <span className="text-green-400 mr-2">•</span>
                      <span>{result}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Experience;